module.exports = __webpack_public_path__ + "img/c-en-24.39b80cce.png";